<template>
  <div class="hello">
    <el-container class="layout-shell">
      <el-aside width="auto" class="layout-aside">
        <!-- 左侧菜单 -->
        <Aside></Aside>
      </el-aside>
      <el-container class="layout-main">
        <el-header class="layout-header" style="border: none;">
          <!-- 顶部区域 -->
          <Header></Header>
        </el-header>
        <!-- 顶部的路由 -->
        <CommonTab class="layout-tabs"></CommonTab>

        <el-main class="main">
          <!-- 路由的出口 -->
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

  
<script>
 import Aside from '@/common/Aside.vue'  //菜单
 import Header from '@/common/Header.vue' //顶部
 import CommonTab from '@/common/CommonTab.vue' //顶部下方的tab状态栏
export default {
  name: "HelloWorld",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
    };
  },
    components: {
    Aside,
    Header,
    CommonTab
  }
}
 
</script>
  
<style lang="less" scoped>
.hello {
  height: 100%;
}

.layout-shell {
  height: 100%;
  min-height: 0;
}

.layout-aside {
  height: 100%;
  overflow: hidden;
}

.layout-main {
  height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.el-header {
  padding: 0;
  flex-shrink: 0;
}

.layout-tabs {
  flex-shrink: 0;
}

.main {
  border-top: 12px;
  height: 100%;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
}
</style>
  



// WEBPACK FOOTER //
// src/common/Home.vue